import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Play, Trash2 } from "lucide-react";
import api from "../../lib/api";
import { playSound } from "../../lib/sounds";
import { inputCls, Field, Panel, btnPrimary, errMsg } from "./ui";

export default function SoundsTab() {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/sounds").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    e.preventDefault();
    if (!file || file.size > 1024 * 1024) { toast.error("Pilih file MP3/WAV/OGG maks 1MB"); return; }
    const fd = new FormData();
    fd.append("name", name);
    fd.append("file", file);
    setBusy(true);
    try {
      await api.post("/sounds", fd);
      toast.success("Bunyi diunggah");
      setName(""); setFile(null); e.target.reset(); load();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const remove = async (s) => {
    if (!window.confirm(`Hapus bunyi "${s.name}"? Pengguna yang memakainya kembali ke bunyi bawaan.`)) return;
    try { await api.delete(`/sounds/${s.id}`); load(); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Panel title="Bunyi Notifikasi Toko" testId="sounds-panel">
      <p className="text-xs text-[#A8A8AD] mb-4">Bunyi yang diunggah bisa dipilih semua Owner, Staff, dan pembeli di halaman Akun untuk notifikasi order & pesan.</p>
      <form onSubmit={upload} className="flex flex-col md:flex-row gap-4 md:items-end mb-6">
        <Field label="Nama bunyi" className="md:w-64">
          <input data-testid="sound-name-input" required maxLength={40} className={inputCls} value={name} onChange={(e) => setName(e.target.value)} />
        </Field>
        <Field label="File (MP3 / WAV / OGG, maks 1MB)">
          <input data-testid="sound-file-input" type="file" required accept="audio/mpeg,audio/wav,audio/ogg,.mp3,.wav,.ogg" onChange={(e) => setFile(e.target.files[0] || null)} className="mt-2 text-xs text-[#A8A8AD]" />
        </Field>
        <button data-testid="sound-upload-btn" type="submit" disabled={busy} className={btnPrimary}>{busy ? "Mengunggah..." : "Unggah"}</button>
      </form>
      {rows.map((s) => (
        <div key={s.id} data-testid={`sound-row-${s.id}`} className="flex items-center gap-3 py-2 border-b border-[#35353B] text-sm text-[#F5F3ED]">
          <span className="flex-1">{s.name}</span>
          <button data-testid={`sound-play-${s.id}`} onClick={() => playSound(`custom:${s.id}`, 0.8)} className="text-[#D4AF37] hover:text-[#F2D98D]" aria-label="Putar"><Play size={16} /></button>
          <button data-testid={`sound-delete-${s.id}`} onClick={() => remove(s)} className="text-[#F06464] hover:text-white" aria-label="Hapus"><Trash2 size={16} /></button>
        </div>
      ))}
      {rows.length === 0 && <div className="text-sm text-[#A8A8AD]">Belum ada bunyi custom</div>}
    </Panel>
  );
}
